import { z } from 'zod';
/**
 * El aviso del paciente (UC-P06, P-07) · el vocabulario, en un solo lugar.
 *
 * Lo nombran tres capas: el evento `patient.event_reported`, el contrato del
 * endpoint que lo recibe y la `Observation` que lo lleva al registro clínico
 * (E3.25, D-03). Hasta E3.25 las tres listas estaban escritas por separado; si
 * se separaban, una categoría nueva entraba a la base sin código en el store, y
 * nada lo avisaba. Ahora las tres salen de acá, y el catálogo de códigos de
 * `@pasos/fhir` está tipado contra esta lista: sumar una categoría no compila
 * hasta que tenga su código.
 *
 * Lista cerrada y sin narrativa: estructurar lo que el paciente escribe es
 * justamente lo diferido en `CLAUDE.md` §4.1.
 */
export const CATEGORIAS_DE_AVISO = [
    'caida',
    'dolor_agudo',
    'movilidad',
    'medicacion',
    'herida',
    'otro',
];
export const categoriaDeAvisoSchema = z.enum(CATEGORIAS_DE_AVISO);
/** Qué tan fuerte le pareció. Opcional en la pantalla: `null` es que no lo dijo. */
export const SEVERIDADES_PERCIBIDAS = ['leve', 'moderada', 'alta'];
export const severidadPercibidaSchema = z.enum(SEVERIDADES_PERCIBIDAS);
//# sourceMappingURL=avisos.js.map